import { ModernOffersComponent } from "../modern-offers/modern-offers.component";
import { FloatingOfferSetTemplateComponent } from "./floating-offer-set-template/floating-offer-set-template.component";
import { OfferSetTemplateBase } from "./offer-set-template-base.component";

type OfferSetComponentsType = {
    [key: string]: (new (...args) => OfferSetTemplateBase)
};

export const OFFER_SET_COMPONENTS: OfferSetComponentsType = {
    'default': ModernOffersComponent,
    'floating': FloatingOfferSetTemplateComponent
}